import querystring from 'querystring';
import { get } from 'lodash';
import { reset } from '@zocdoc-frontend-common/components-phoneverification/Actions';
import { fetchServiceTypes } from '@zocdoc-frontend-common/components-phoneverification/PhoneActions';
import { BusinessUnit, EVENT_TYPES } from '../../../constants';
import * as SchedulingActions from '../../actions/SchedulingActions';
import { showValidationErrors } from '../../components/AppointmentRequirements/AppointmentRequirementsActions';
import { showSecureHeader } from '../../components/BookingContainer/BookingContainerActions';
import { MEMBER_ID_SOURCE_TYPE } from '../../constants';
import { paths } from '../../paths';
import {
    logEvent,
    pushWithQuery,
    redirectOnErrorResponse,
    wrapWithDispatch,
} from '../../utils';
import { startLUXPageTransition } from '../../utils/LUXUtils';
import * as Actions from './AppointmentDetailsActions';

export const mapDispatchToProps = (dispatch, ownProps) => ({
    fetchInsuranceInfo: (carrierId, planId) => {
        dispatch(Actions.getInsuranceCarrierName(carrierId));
        dispatch(Actions.getInsurancePlanName(carrierId, planId));
    },
    fetchServiceTypes: () => {
        dispatch(fetchServiceTypes());
    },
    getBookingState: (bookingId, forceFetch) => {
        dispatch(SchedulingActions.getBookingState(bookingId, forceFetch));
    },
    resetPhoneVerificationPage: () => {
        dispatch(reset());
    },
    onClickBookAppointment: ({
        bookingId,
        validState,
        insuranceIdRequired,
    }) => {
        dispatch(Actions.trackClickBookAppointment());
        dispatch(Actions.trackBookingApptClicked());

        if (validState) {
            dispatch(SchedulingActions.submitBooking(bookingId));
        } else {
            dispatch(showValidationErrors(insuranceIdRequired));
        }
    },
    onEnterInsuranceId: (e) => {
        const val = get(e, 'target.value', '');
        dispatch(Actions.enterInsuranceId(val));
    },
    onEnterDoctorNotes: (doctorNotes) => {
        dispatch(
            Actions.enterDoctorNotes(
                doctorNotes,
                MEMBER_ID_SOURCE_TYPE.PATIENT_INPUT
            )
        );
    },
    onFakeAppointmentChanged: (e, bookingState) => {
        dispatch(
            SchedulingActions.updateBookingState({
                ...bookingState,
                is_fake_appointment: e,
            })
        );
    },
    onBookingFailure: ({
        bookingErrorCode,
        bookingErrors,
        bookingState,
        bookingStatus,
        providerLocationPhone,
    }) => {
        const bookingId = get(ownProps, 'params.bookingId');
        return redirectOnErrorResponse(dispatch, {
            bookingId,
            bookingErrorCode,
            bookingErrors,
            bookingState,
            bookingStatus,
            providerLocationPhone,
        });
    },
    onBookingSuccess: (usePatientHomeAsBookingComplete = false) => {
        setTimeout(() => {
            dispatch(showSecureHeader(false));
            startLUXPageTransition();
            if (usePatientHomeAsBookingComplete) {
                /*
                    NOTE: React router doesn't recognize /patient/medicalteam
                    as a valid url, so dispatching pushWithQuery won't work in
                    this scenario. Below, you will also see logic for preserving
                    exising query string parameters in the url
                */
                const queryStringDict = querystring.parse(
                    window.location.search.substring(1)
                );
                queryStringDict.bookingId = ownProps.params.bookingId;
                const existingQueryStringWithBookingId =
                    querystring.stringify(queryStringDict);

                const redirectPath = `/patient/medicalteam/?${existingQueryStringWithBookingId}`;
                window.location.assign(redirectPath);
            } else {
                dispatch(
                    pushWithQuery({
                        pathname: `${paths.bookingCompletePath}/${ownProps.params.bookingId}`,
                        search: window.location.search,
                    })
                );
            }
        }, ownProps.animationDelay);
    },
    logDidHideSyncOverlay: () => {
        logEvent({
            event: { type: EVENT_TYPES.DidHideSyncOverlay },
            businessUnit: BusinessUnit.PATIENT_WEB_APP,
            bookingId: ownProps.params.bookingId,
        });
    },
    logDidShowSyncOverlay: () => {
        logEvent({
            event: { type: EVENT_TYPES.DidShowSyncOverlay },
            businessUnit: BusinessUnit.PATIENT_WEB_APP,
            bookingId: ownProps.params.bookingId,
            dispatch,
        });
    },
    trimInsuranceId: () => {
        dispatch(Actions.trimInsuranceId());
    },
    ...wrapWithDispatch(Actions.AppointmentDetailsActionCreators, dispatch),
});

export default mapDispatchToProps;
